import { jsx } from "panel";
import keyBy from "lodash/keyBy";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { DisplaySize, Placement } from "common/components/tooltip/types";
import { RevealableTextEditEl } from "common/components/revealable-text-editor";
import { InputSize } from "common/components/input/types";
import { ButtonEl } from "common/components/button";
import { TextHighlightEl } from "common/components/text-highlight";
import { ButtonTheme } from "common/components/button/constants";
import { DropMenuEl } from "common/components/drop-menu";
import { PATH_SEPARATOR } from "common/constants";
import { Visibility, VisibilityEvents } from "common/components/base/stackable";
const MAX_DESCRIPTION_DISPLAY_LENGTH = 400;
var DEFAULT_ICON = /* @__PURE__ */ ((DEFAULT_ICON2) => {
  DEFAULT_ICON2["PERSON"] = `person`;
  DEFAULT_ICON2["FIRE"] = `fire`;
  DEFAULT_ICON2["PULSE"] = `pulse`;
  return DEFAULT_ICON2;
})(DEFAULT_ICON || {});
const defaultMetrics = {
  person: {
    icon: "person" /* PERSON */,
    tooltip: `There is no associated data.`,
    value: `-`
  },
  fire: {
    icon: "fire" /* FIRE */,
    tooltip: `There is no associated data.`,
    value: `-`
  },
  pulse: {
    icon: "pulse" /* PULSE */,
    tooltip: `There is no associated data.`,
    value: `-`
  }
};
export function template() {
  if (!this.helpers.isTooltipDataSet()) {
    return null;
  }
  const { description } = this.state;
  const {
    header,
    subHeader,
    path,
    createdBy,
    entityType,
    entityIcon,
    trackedAs,
    editItem,
    links,
    isUnsaved,
    details,
    metrics: measuredMetrics,
    actions,
    extraInfo,
    isRecentlyUsed,
    hideMetricsSection
  } = this.attr(`tooltip-data`);
  const HeaderEl = () => {
    return /* @__PURE__ */ jsx("div", {
      sel: ".header"
    }, entityIcon ? /* @__PURE__ */ jsx("div", {
      sel: ".header-icon"
    }, /* @__PURE__ */ jsx(SvgIconEl, {
      attrs: { icon: entityIcon }
    }), entityType ? /* @__PURE__ */ jsx(TooltipEl, {
      sel: ".header-icon-tooltip",
      attrs: { placement: Placement.Top }
    }, /* @__PURE__ */ jsx("div", null, " ", entityType, " "), createdBy ? /* @__PURE__ */ jsx("div", {
      sel: ".definition-created-by"
    }, " Created by ", createdBy.name, " ") : null) : null) : null, /* @__PURE__ */ jsx("div", {
      sel: ".header-text"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".heading",
      class: { "is-unsaved": isUnsaved }
    }, (path == null ? void 0 : path.length) > 0 && /* @__PURE__ */ jsx("span", {
      sel: ".path"
    }, [...path, ``].join(PATH_SEPARATOR)), /* @__PURE__ */ jsx("span", {
      sel: ".leaf"
    }, header, isUnsaved ? `*` : null)), subHeader ? /* @__PURE__ */ jsx("div", {
      sel: ".subheader"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".text"
    }, subHeader)) : null, trackedAs ? /* @__PURE__ */ jsx("div", {
      sel: ".subheader"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".text"
    }, `Tracked as `), /* @__PURE__ */ jsx("div", {
      sel: ".tracked-as"
    }, trackedAs)) : null));
  };
  const FooterEl = () => /* @__PURE__ */ jsx("div", {
    sel: ".footer"
  }, (actions == null ? void 0 : actions.length) > 0 && actions.map((action) => /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".action-button",
    attrs: {
      "hide-input-focus-styling": true,
      theme: ButtonTheme.Tertiary,
      icon: action.icon || ``,
      disabled: action.disabled,
      readonly: action.readonly,
      href: action.href,
      elref: action.label,
      role: `button`,
      tooltip: { text: action.label, placement: Placement.Top, size: DisplaySize.Small }
    },
    on: {
      click: () => this.helpers.actionClick(action)
    }
  })), (links == null ? void 0 : links.length) > 0 && links.map((link) => /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".link-button",
    attrs: {
      "hide-input-focus-styling": true,
      theme: ButtonTheme.Tertiary,
      icon: link.icon,
      role: `button`,
      href: link.href,
      tooltip: { text: link.tooltipText, placement: Placement.Top, size: DisplaySize.Small }
    },
    on: {
      click: () => this.helpers.linkClick(link)
    }
  })));
  const iconsToDisplay = ["person" /* PERSON */, "fire" /* FIRE */, "pulse" /* PULSE */];
  const metricDataByIcon = keyBy(measuredMetrics || [], `icon`);
  const metrics = iconsToDisplay.map((icon) => metricDataByIcon[icon] || defaultMetrics[icon]);
  const contextPanelContent = /* @__PURE__ */ jsx("div", {
    style: { borderRadius: `9px` },
    on: {
      mouseenter: this.helpers.handleMouseEnter,
      mouseleave: this.helpers.handleMouseLeave
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".root"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".container"
  }, (() => {
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(HeaderEl, null), /* @__PURE__ */ jsx("div", {
      sel: ".content-body"
    }, !hideMetricsSection && /* @__PURE__ */ jsx("div", {
      sel: ".metrics-section"
    }, metrics == null ? void 0 : metrics.map((metric, idx) => /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".metric"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".metric-icon"
    }, /* @__PURE__ */ jsx(SvgIconEl, {
      attrs: { icon: metric.icon }
    })), /* @__PURE__ */ jsx("div", {
      sel: ".metric-value"
    }, metric.value), /* @__PURE__ */ jsx(TooltipEl, {
      attrs: { placement: Placement.Top }
    }, metric.tooltip)), idx < metrics.length - 1 && /* @__PURE__ */ jsx("div", {
      sel: ".metric-divider"
    })))), isRecentlyUsed ? /* @__PURE__ */ jsx("div", {
      sel: ".recently-used"
    }, /* @__PURE__ */ jsx(SvgIconEl, {
      attrs: { icon: `time` }
    }), "Recently used by you") : null, /* @__PURE__ */ jsx("div", {
      sel: ".description"
    }, description || editItem ? /* @__PURE__ */ jsx(RevealableTextEditEl, {
      attrs: {
        text: description,
        "hide-footer": true,
        "add-text-placeholder": `+ Add Description...`,
        placeholder: `Please add a description`,
        "disable-edit": !editItem,
        size: InputSize.Medium
      },
      on: {
        changedText: (ev) => this.helpers.handleTextEditorSave(ev, editItem)
      },
      hook: {
        insert: this.helpers.editorInserted
      }
    }, (() => {
      return /* @__PURE__ */ jsx("div", {
        sel: ".description-content",
        attrs: { slot: `content` }
      }, editItem ? /* @__PURE__ */ jsx("div", {
        sel: ".description-text-wrapper"
      }, description ? this.helpers.formatText(description, {
        className: `description-text`,
        maxLength: MAX_DESCRIPTION_DISPLAY_LENGTH
      }) : `+ Add Description...`, /* @__PURE__ */ jsx("div", {
        sel: ".editable-icon"
      }, /* @__PURE__ */ jsx(ButtonEl, {
        sel: ".edit-description-button",
        attrs: {
          icon: `edit`,
          theme: ButtonTheme.Tertiary
        }
      }))) : /* @__PURE__ */ jsx("div", {
        sel: ".description-text-wrapper"
      }, this.helpers.formatText(description, {
        className: `description-text`,
        maxLength: MAX_DESCRIPTION_DISPLAY_LENGTH
      })));
    })()) : null), details && details.length ? /* @__PURE__ */ jsx("div", {
      sel: ".details"
    }, details.map((detail) => /* @__PURE__ */ jsx("div", {
      sel: ".detail"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".name"
    }, detail.name), /* @__PURE__ */ jsx("div", {
      sel: ".value"
    }, Array.isArray(detail.value) && detail.value.map((value) => /* @__PURE__ */ jsx(TextHighlightEl, {
      attrs: { theme: `generic`, text: value }
    })))))) : null, extraInfo && extraInfo.length ? /* @__PURE__ */ jsx("div", {
      sel: ".extra-info"
    }, extraInfo.map((info) => /* @__PURE__ */ jsx("div", {
      sel: ".info"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".icon"
    }, /* @__PURE__ */ jsx(SvgIconEl, {
      attrs: { icon: `info` }
    })), /* @__PURE__ */ jsx("div", {
      sel: ".value"
    }, info)))) : null));
  })())), /* @__PURE__ */ jsx(FooterEl, null));
  return /* @__PURE__ */ jsx(DropMenuEl, {
    attrs: {
      open: Boolean(this.attr(`tooltip-data`)),
      offset: this.attr(`offset`),
      skidding: this.attr(`skidding`),
      direction: this.attr(`placement`),
      "position-strategy": this.attr(`position-strategy`),
      "show-arrow": this.attr(`show-arrow`),
      "allowed-flip-directions": this.attr(`force-placement`) && [this.attr(`placement`)]
    },
    props: {
      positionParent: this.tooltipPositionParentElement
    },
    on: {
      click: (ev) => {
        if (!(ev.target instanceof HTMLAnchorElement)) {
          ev.stopPropagation();
          ev.preventDefault();
        }
      }
    },
    hook: {
      destroy: (vnode) => {
        const dropEl = vnode.elm;
        this.dispatchEvent(
          new CustomEvent(VisibilityEvents[Visibility.Closed], {
            bubbles: true,
            composed: true,
            detail: dropEl.getStackingDetail()
          })
        );
      }
    }
  }, contextPanelContent);
}
